/**
 * @generated SignedSource<<7070b1c76510bb36bc08b94294826fb5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StartPageQuery$variables = {
  draftId: string;
  hasDraft: boolean;
};
export type StartPageQuery$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"StartFlow_user">;
  } | null | undefined;
  readonly landlordOnboardingDraft?: {
    readonly areaPreview: {
      readonly " $fragmentSpreads": FragmentRefs<"StartPage_preview">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"StartFlow_draft">;
  } | null | undefined;
};
export type StartPageQuery = {
  response: StartPageQuery$data;
  variables: StartPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasDraft"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "draftId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StartFlow_user"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "hasDraft",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "LandlordOnboardingDraft",
            "kind": "LinkedField",
            "name": "landlordOnboardingDraft",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StartFlow_draft"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordAreaPreview",
                "kind": "LinkedField",
                "name": "areaPreview",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "StartPage_preview"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StartPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "hasDraft",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "LandlordOnboardingDraft",
            "kind": "LinkedField",
            "name": "landlordOnboardingDraft",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "situation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frustrations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentAgentName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceWanted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordAreaPreview",
                "kind": "LinkedField",
                "name": "areaPreview",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formattedAddress",
                    "storageKey": null
                  },
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "placesFetchedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordAgentMapPin",
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v3/*:: as any*/),
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "propertyFetchedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordAreaPreviewProperty",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentEnergyRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentEnergyScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "potentialEnergyRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "potentialEnergyScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiry",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "propertyType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "builtForm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "floorAreaSqm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "constructionAge",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "454e4a541164e575d314e7e5e126e2b7",
    "id": null,
    "metadata": {},
    "name": "StartPageQuery",
    "operationKind": "query",
    "text": "query StartPageQuery(\n  $draftId: ID!\n  $hasDraft: Boolean!\n) {\n  currentUser {\n    ...StartFlow_user\n    id\n  }\n  landlordOnboardingDraft(id: $draftId) @include(if: $hasDraft) {\n    ...StartFlow_draft\n    areaPreview {\n      ...StartPage_preview\n      id\n    }\n    id\n  }\n}\n\nfragment CompareAgentMap_pin on LandlordAgentMapPin {\n  id\n  name\n  latitude\n  longitude\n  state\n}\n\nfragment StartAuthenticatedStep_user on User {\n  firstName\n  lastName\n}\n\nfragment StartFlow_draft on LandlordOnboardingDraft {\n  id\n  ...useStartOnboardingDraft_draft\n}\n\nfragment StartFlow_preview on LandlordAreaPreview {\n  ...StartReportAuth_preview\n}\n\nfragment StartFlow_user on User {\n  ...StartAuthenticatedStep_user\n}\n\nfragment StartPage_preview on LandlordAreaPreview {\n  id\n  ...StartFlow_preview\n  ...StartPropertyReveal_preview\n  ...StartStepShell_preview\n}\n\nfragment StartPropertyReveal_preview on LandlordAreaPreview {\n  formattedAddress\n  latitude\n  longitude\n  propertyFetchedAt\n  placesFetchedAt\n  agents {\n    ...CompareAgentMap_pin\n    id\n  }\n  property {\n    currentEnergyRating\n    currentEnergyScore\n    potentialEnergyRating\n    potentialEnergyScore\n    expiry\n    propertyType\n    builtForm\n    floorAreaSqm\n    constructionAge\n  }\n}\n\nfragment StartReportAuth_preview on LandlordAreaPreview {\n  id\n  formattedAddress\n  latitude\n  longitude\n  placesFetchedAt\n  agents {\n    id\n    name\n    latitude\n    longitude\n  }\n}\n\nfragment StartStepShell_preview on LandlordAreaPreview {\n  formattedAddress\n  property {\n    currentEnergyRating\n  }\n  placesFetchedAt\n  agents {\n    __typename\n    id\n  }\n}\n\nfragment useStartOnboardingDraft_draft on LandlordOnboardingDraft {\n  id\n  situation\n  frustrations\n  currentAgentName\n  serviceWanted\n}\n"
  }
};
})();

(node as any).hash = "d2b398761ac33fdab16cbb56c606bf20";

export default node;
